import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
export default function Dashboard(){
  return (
    <Container sx={{py:4}}>
      <Typography variant="h4">Dashboard</Typography>
      <Box sx={{mt:2}}>
        <Button variant="contained" href="/player">Open Player</Button>
      </Box>
      <Typography sx={{mt:2}}>Manage ads & products in the admin panel (PHP backend).</Typography>
    </Container>
  );
}
